/**
 * This file contains all the events configurations required by the editor including : default data for any new event, event name and desc..etc
 */
import { Translate, I18n } from "react-redux-i18n";
import React from "react";
import { beeTemplate } from "assets/js/scenes/campaigns/scenes/campaignFlow/data/baseTemplates";
import { EDITORS } from "assets/js/const/Campaign";

const startingFromScratchInitialElements = [
	{
		id: "1",
		type: "editorNode",
		data: {
			text: "1",
			initialElement: true,
			type: "helper_trigger",
			selected: true,
		},
		draggable: false,
		position: { x: 350, y: 0 },
	},
];

const stripeTriggerEvents = () => [
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-chargeSucceeded_tileTitle"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-chargeSucceeded_tileTitle",
		id: "Stripe.ChargeSucceeded",
		defaultValues: {
			tags: [],
		},
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-StripeCustomerSubscriptionCreated_tileTitle"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-StripeCustomerSubscriptionCreated_tileTitle",
		id: "Stripe.CustomerSubscriptionCreated",
		defaultValues: {
			tags: [],
		},
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-StripeCustomerSubscriptionDeleted_tileTitle"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-StripeCustomerSubscriptionDeleted_tileTitle",
		id: "Stripe.CustomerSubscriptionDeleted",
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-StripeInvoicePaymentFailed_tileTitle"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-StripeInvoicePaymentFailed_tileTitle",
		id: "Stripe.InvoicePaymentFailed",
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-StripeInvoicePaymentSucceeded_tileTitle"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-StripeInvoicePaymentSucceeded_tileTitle",
		id: "Stripe.InvoicePaymentSucceeded",
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-StripeInvoiceUpcoming_tileTitle"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-StripeInvoiceUpcoming_tileTitle",
		id: "Stripe.InvoiceUpcoming",
	},
	{
		name: "Stripe.CustomerSubscriptionUpdated",
		type: "trigger",
		tileTitle: "Stripe.CustomerSubscriptionUpdated",
		id: "Stripe.CustomerSubscriptionUpdated",
	},
	{
		name: "Stripe.InvoiceOverdue",
		type: "trigger",
		tileTitle: "Stripe.InvoiceOverdue",
		id: "Stripe.InvoiceOverdue",
	},

];

const recurringTriggerEvents = () => [
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-on-schedule_title"),
		desc: I18n._translate(
			"app-automation-editor_events_trigger-on-schedule_desc"
		),
		type: "trigger",
		tileTitle: "",
		id: "onSchedule",
		defaultValues: {
			time: "1 1 * * 1",
			timezone: ""
		},
	}
];
const TriggerEvents = () => [
	{
		name: I18n._translate("app-automation-editor_events_trigger-1_name"),
		desc: I18n._translate("app-automation-editor_events_trigger-1_desc"),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-1_tileTitle",
		id: "subscribed",
		//internal: true,
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_trigger-contact-tagged_name"
		),
		desc: I18n._translate(
			"app-automation-editor_events_trigger-contact-tagged_desc"
		),
		type: "trigger",
		tileTitle: "app-automation-editor_events_trigger-contact-tagged_tileTitle",
		id: "contactTagged",
		defaultValues: {
			tags: [],
		},
	},

];
const ContextualEvents = () => [
	{
		name: I18n._translate("app-automation-editor_events_contextual-1_name"),
		desc: I18n._translate("app-automation-editor_events_contextual-1_desc"),
		type: "condition",
		tileTitle: "app-automation-editor_events_contextual-1_tileTitle",
		id: "segmentSelection",
	},
];
const ActionEvents = (senderId) => [
	{
		name: I18n._translate("app-automation-editor_events_action-1_name"),
		desc: I18n._translate("app-automation-editor_events_action-1_desc"),
		type: "action",
		tileTitle: "app-automation-editor_events_action-1_tileTitle",
		id: "sendEmail",
		defaultValues: {
			isEmailEdited: false,
			thumbnailUrl:
				"https://screenshots2.wbsrvcx.com/3cb941e1b3b84fcfe7a8d5978cc1c9d4/400/560/https%3A%2F%2Fapi.cakemail.dev%2Fworkflows%2FFBmzHVrr1kGydjhnq89n%2Factions%2FcktenTUClmJMBG6OUSUS%2Frender%3Ftoken%3D02c1ce2a5a0cd5043913a91535767bc8%26account_id%3D870702?bust=1651102578",
			email: {
				name: I18n._translate("app-campaigns-flow-template_essentials"),
				content: {
					type: EDITORS.BEE,
					subject: "",
					id: "scratchBee1",
					json: beeTemplate(),
				},
			},
			additional_params: "",
			senderId: senderId,
			actionName: I18n._translate("app-automations-action-default_name"),
		},
	},
	{
		name: I18n._translate("app-automation-editor_events_action-2_name"),
		desc: I18n._translate("app-automation-editor_events_action-2_desc"),
		type: "action",
		tileTitle: "app-automation-editor_events_action-2_tileTitle",
		id: "loop",
		defaultValues: {
			loopFor: 1,
			loopType: "finite",
			waitFor: "10 Minutes",
		},
		canNotBeLoopedTo: true,
	},
	{
		name: I18n._translate("app-automation-editor_events_action-3_name"),
		desc: I18n._translate("app-automation-editor_events_action-3_desc"),
		type: "action",
		tileTitle: "app-automation-editor_events_action-3_tileTitle",
		id: "updateContact",
		defaultValues: { customAttributes: [], customAttributeAction: "update", hasStripeIntegration: false, incrementAttribute: false },
	},
	{
		name: I18n._translate(
			"app-automation-editor_events_action-updateContactTags_name"
		),
		desc: I18n._translate(
			"app-automation-editor_events_action-updateContactTags_desc"
		),
		type: "action",
		tileTitle:
			"app-automation-editor_events_action-updateContactTags_tileTitle",
		id: "updateContactTags",
		defaultValues: { tags: [] },
	}
];

const RSSActionEvents = (automationId) => [
	{
		name: I18n._translate("app-automation-editor_events_action-RSS-1_name"),
		desc: I18n._translate("app-automation-editor_events_action-RSS-1_desc"),
		type: "action",
		tileTitle: "app-automation-editor_events_action-RSS-1_name",
		id: "rssStore",
		defaultValues: {

		},
	},
];

const emailAPIActionEvent = (automationId) => [
	{
		name: I18n._translate("app-automation-editor_events_action-1_email_api_name"),
		desc: I18n._translate("app-automation-editor_events_action-1_desc"),
		type: "action",
		tileTitle: "app-automation-editor_events_action-1_tileTitle",
		id: "emailAPI",
		defaultValues: {
			isEmailEdited: false,
			thumbnailUrl:
				"https://screenshots2.wbsrvcx.com/3cb941e1b3b84fcfe7a8d5978cc1c9d4/400/560/https%3A%2F%2Fapi.cakemail.dev%2Fworkflows%2FFBmzHVrr1kGydjhnq89n%2Factions%2FcktenTUClmJMBG6OUSUS%2Frender%3Ftoken%3D02c1ce2a5a0cd5043913a91535767bc8%26account_id%3D870702?bust=1651102578",
			content: {
				template: {
					id: 0
				},
				subject: "",
				type: "marketing"
			},
			contact_id: 0,
			email: "",
			list_id: 0,
			additional_params: "",
			sender: {
				id: "",
				name: ""
			},
			tags: [`automation_${automationId}`.toLowerCase()],
			actionName: I18n._translate("app-automations-action-default_name"),
		},
	}
];

const recurringConditionEvents = () => [
	{
		name: "Filter contacts",
		desc: "Filter contacts of your list that will be used in the next step",
		type: "condition",
		tileTitle: "app-automation-editor_events_action_recurring_filter_titleTile",
		id: "filterSet",
		conditions: { operator: "and", conditions: [] },
	},
];

const RSSConditionEvents = () => [
	{
		name: I18n._translate("app-automation-editor_events_condition-RSS-1_name"),
		desc: I18n._translate("app-automation-editor_events_condition-RSS-1_desc"),
		type: "condition",
		tileTitle: "app-automation-editor_events_condition-RSS-1_name",
		id: "rssCheck",
		defaultValues: {
			minNewItems: 1
		},
	},
];



const hiddenActionEvents = () => [
	{
		name: I18n._translate(
			"app-automation-editor_events_action-addContact_tileTitle"
		),
		desc: I18n._translate(
			"app-automation-editor_events_action-addContact_desc"
		),
		type: "action",
		tileTitle:
			"app-automation-editor_events_action-addContact_tileTitle",
		id: "addContact",
	},
];
const ConditionEvents = () => [
	{
		name: I18n._translate("app-automation-editor_events_condition-1_name"),
		desc: I18n._translate("app-automation-editor_events_condition-1_desc"),
		type: "condition",
		tileTitle: "app-automation-editor_events_condition-1_tileTitle",
		id: "delay",
		defaultValues: {
			delay: "1 Seconds",
		},
		canNotBeLoopedTo: true,
	},
	{
		name: I18n._translate("app-automation-editor_events_condition-2_name"),
		desc: I18n._translate("app-automation-editor_events_condition-2_desc"),
		type: "condition",
		tileTitle: "app-automation-editor_events_condition-2_tileTitle",
		id: "ifElse",
		defaultValues: {
			elseCondition: "and",
		},
		conditions: { operator: "and", conditions: [] },
		configs: {
			noOfLinks: 2,
			label1: "Yes",
			label2: "No",
		},
	},
	{
		name: I18n._translate("app-automation-editor_events_condition-3_name"),
		desc: I18n._translate("app-automation-editor_events_condition-3_desc"),
		type: "condition",
		tileTitle: "app-automation-editor_events_condition-3_titleTile",
		percentage: {
			primary: 50,
			sec: 50,
		},
		id: "split50",
		configs: {
			noOfLinks: 2,
			label1: "A",
			label2: "B",
		},
	},
	{
		name: I18n._translate("app-automation-editor_events_condition-4_name"),
		desc: I18n._translate("app-automation-editor_events_condition-4_desc"),
		type: "condition",
		tileTitle: "app-automation-editor_events_condition-4_titleTile",
		id: "abTest",
		defaultValues: {
			winnerCriteria: "clicked",
		},
		configs: {
			noOfLinks: 2,
			label1: "A",
			label2: "B",
		},
		internal: true,
		canNotBeLoopedTo: true,
	}
];
const triggerNewNode = {
	id: "1",
	type: "editorNode",
	data: {
		text: "1",
		initialElement: true,
		type: "trigger",
		selected: true,
	},
	draggable: false,
	position: { x: 350, y: 0 },
};
export {
	startingFromScratchInitialElements,
	TriggerEvents,
	triggerNewNode,
	recurringTriggerEvents,
	emailAPIActionEvent,
	stripeTriggerEvents,
	ConditionEvents,
	ActionEvents,
	RSSActionEvents,
	RSSConditionEvents,
	recurringConditionEvents,
	ContextualEvents,
	hiddenActionEvents
};
